module.exports = __webpack_public_path__ + "img/pr-3.9ad53f5e.png";